<app-view-title Title="{{ 'Intellitrailer.Rental.SecurityCheck.Headline' | translate : 'Security check' }}" [isPrimaryColor]="false"></app-view-title>
<view-content [centered]="true">
  @if(event != 'FaultReport') {
  @if(rentalObjectTitle != null){
  <h2>Trailer: {{rentalObjectTitle}} @if(booking.RentalObject.Alias && !this.booking.IsOneWay && !this.isNuwiel){<span> - {{booking.RentalObject.Alias}}</span>}</h2>
  }
  <h2>{{ 'Intellitrailer.Rental.SecurityCheck.lblCheckCurrentCond' | translate : 'Check the current condition of the trailer below:' }}</h2>
  }
  <div class="propertyTable">
    <div class="row">
      <div class="col col-6">&nbsp;</div>
      <div class="col col-3">
        <img src="../../../assets/Images/okay.png" />
        <span class="green-ok">OK</span>
      </div>
      <div class="col col-3">
        <img src="../../../assets/Images/not-okay.png" />
        <span class="red-faulty">{{ 'Intellitrailer.Rental.SecurityCheck.Faulty' | translate : 'Faulty' }}</span>
      </div>
    </div>
    <div class="row align-items-center" *ngFor="let p of securityCheck.CheckPoints">
      <div class="col col-6">{{ p.Name | translate}}</div>
      <div class="col col-3">
        <button class="circle-button" mat-raised-button (click)="setCheck(p, true)" [ngClass]="p.Ok ? 'checkedg' : 'unchecked'">@if(p.Ok) { <mat-icon class="done">done</mat-icon> }</button>
        @if(false) { <mat-checkbox class="checkOk" [(ngModel)]="p.Ok"></mat-checkbox> }
      </div>
      <div class="col col-3">
        <button class="circle-button" mat-raised-button (click)="setCheck(p, false)" [ngClass]="p.Failed ? 'checkedr' : 'unchecked'">@if(p.Failed) { <mat-icon class="clear">clear</mat-icon> }</button>
        @if(false) { <mat-checkbox class="checkFailed" [(ngModel)]="p.Failed"> </mat-checkbox> }
      </div>
    </div>
  </div>

  @if(event == 'Pickup' && securityCheck?.HasDeviation && !booking.IsOneWay){
  <div class="row">
    <div class="col">
      <p class="link" style="color:black !important;" (click)="swapTrailer()">{{ 'Intellitrailer.Rental.SecurityCheck.txtChangeTrailer' | translate : 'Change trailer?' }}</p>
    </div>
  </div>
  }

  <mat-form-field appearance="outline">
    <textarea matInput placeholder="{{ 'Intellitrailer.Rental.SecurityCheck.txtRemarksInfo' | translate : 'Additional feedback about the trailer' }}" [(ngModel)]="securityCheck.Remarks" rows="2"></textarea>
  </mat-form-field>
  @if(securityCheck.HasDeviation) { <p>{{ 'Intellitrailer.Rental.SecurityCheck.txtFaultsInfo' | translate : 'You have marked something as faulty. In the next step you will be asked to take a photo of that part to document it for us.' }}</p> }
</view-content>
<view-actions mode="white">
  @if (event != 'FaultReport') {
    <button mat-raised-button [disabled]="securityCheck.IsValid" (click)="confirm()">{{ 'Intellitrailer.Rental.SecurityCheck.cmdConfirm' | translate : 'Confirm' }}</button>
  } @else {
    <button mat-raised-button [disabled]="securityCheck.IsValid" (click)="confirm()">{{ 'Intellitrailer.Navigation.Next' | translate : 'Next' }}</button>
  }
</view-actions>

